<nem-layout [contentWithScroll]="true" [topSlot]="false" [gridColumns]="false" [customContentClass]="['pi-0']">
  <section class="relative pt-24 pb-16 px-4 overflow-hidden">
    <div
      class="absolute inset-0 bg-[linear-gradient(to_right,#80808012_1px,transparent_1px),linear-gradient(to_bottom,#80808012_1px,transparent_1px)] bg-[size:24px_24px] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_0%,#000_70%,transparent_100%)] pointer-events-none"></div>
    <div
      class="absolute top-[-10%] left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-[#6d28d9] opacity-[0.15] blur-[100px] rounded-full pointer-events-none"></div>

    <div class="relative max-w-5xl mx-auto text-center z-10">
      <div class="flex justify-center mb-8">
        <nem-logo [width]="220"></nem-logo>
      </div>

      <div
        class="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white border border-indigo-100 text-[#6d28d9] text-sm font-semibold mb-8 shadow-sm">
        <span class="relative flex h-2.5 w-2.5">
          <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-indigo-400 opacity-75"></span>
          <span class="relative inline-flex rounded-full h-2.5 w-2.5 bg-[#6d28d9]"></span>
        </span>
        Advanced Analytics for the Australian Energy Market
      </div>

      <h1 class="text-5xl md:text-[4rem] font-extrabold text-slate-900 tracking-tight leading-tight mb-6">
        We turn NEM data into <br class="hidden sm:block" />
        <span class="text-transparent bg-clip-text bg-gradient-to-r from-[#6d28d9] to-[#ec4899]">
          useful information.
        </span>
      </h1>

      <p class="text-lg md:text-xl text-slate-500 max-w-3xl mx-auto mb-14 leading-relaxed font-medium">
        A powerful investigation tool for the Australian National Electricity Market. <br class="hidden md:block" />
        Designed for scholars, advisors, administrators, and executives to stimulate ideas
        <br class="hidden md:block" />
        and access underlying data instantly.
      </p>

      <div class="flex justify-center items-center relative z-20">
        @if (!authenticated) {
        <div class="relative inline-block group cursor-pointer" routerLink="/login">
          <div
            class="absolute inset-0 bg-[#6d28d9] blur-xl opacity-30 group-hover:opacity-50 transition-opacity duration-500 rounded-full"></div>
          <p-button
            label="Sign In to Dashboard"
            icon="pi pi-arrow-right"
            iconPos="right"
            styleClass="relative flex items-center gap-2 px-8 py-3 bg-white/90 hover:bg-white text-slate-800 border border-slate-100 rounded-full font-semibold shadow-sm transition-transform duration-300 group-hover:-translate-y-0.5">
          </p-button>
        </div>
        } @else {
        <div class="relative inline-block group cursor-pointer" routerLink="/dashboard/regional">
          <div
            class="absolute inset-0 bg-emerald-500 blur-xl opacity-40 group-hover:opacity-60 transition-opacity duration-500 rounded-full"></div>
          <p-button
            label="Open Dashboard"
            icon="pi pi-chart-line"
            styleClass="relative flex items-center gap-2 px-8 py-3 bg-emerald-500 hover:bg-emerald-600 text-white border border-emerald-500 rounded-full font-semibold shadow-sm transition-transform duration-300 group-hover:-translate-y-0.5">
          </p-button>
        </div>
        }
      </div>

      <div class="mt-16 mx-auto max-w-4xl relative pointer-events-none hidden md:block">
        <div
          class="absolute -inset-1 bg-gradient-to-r from-[#6d28d9] to-[#ec4899] rounded-2xl opacity-20 blur-lg"></div>

        <div
          class="relative rounded-2xl bg-white/40 backdrop-blur-xl border border-white/60 shadow-2xl overflow-hidden">
          <div class="flex items-center gap-2 px-4 py-3 border-b border-white/40 bg-white/30">
            <div class="w-3 h-3 rounded-full bg-slate-300/80"></div>
            <div class="w-3 h-3 rounded-full bg-slate-300/80"></div>
            <div class="w-3 h-3 rounded-full bg-slate-300/80"></div>
          </div>

          <div class="p-6 grid grid-cols-3 gap-6 opacity-60">
            <div class="col-span-2 h-48 rounded-xl bg-white/50 border border-white/50 flex items-end p-4 gap-3">
              <div class="w-full bg-indigo-300/60 rounded-t-md h-[40%]"></div>
              <div class="w-full bg-indigo-400/60 rounded-t-md h-[70%]"></div>
              <div class="w-full bg-[#6d28d9]/60 rounded-t-md h-[50%]"></div>
              <div class="w-full bg-[#ec4899]/50 rounded-t-md h-[90%]"></div>
              <div class="w-full bg-indigo-500/60 rounded-t-md h-[60%]"></div>
              <div class="w-full bg-indigo-300/60 rounded-t-md h-[75%]"></div>
            </div>
            <div class="col-span-1 h-48 rounded-xl bg-white/50 border border-white/50 p-5 flex flex-col gap-4">
              <div class="w-full h-4 bg-slate-300/50 rounded-full"></div>
              <div class="w-2/3 h-4 bg-slate-300/50 rounded-full"></div>
              <div class="w-full h-full bg-[#6d28d9]/10 rounded-lg mt-auto border border-[#6d28d9]/20"></div>
            </div>
          </div>
        </div>

        <div class="absolute bottom-0 inset-x-0 h-32 bg-gradient-to-t from-slate-50 to-transparent z-10"></div>
      </div>
    </div>
  </section>

  <section class="border-y border-slate-200 bg-white py-10 my-12">
    <div
      class="max-w-4xl mx-auto flex flex-wrap justify-center items-center gap-12 opacity-70 grayscale hover:grayscale-0 transition-all duration-500">
      <img alt="VEPC logo" height="70" src="/assets/images/vepc-logo.png" />
      <img alt="Victoria university logo" height="80" src="/assets/images/victoria_uni.png" />
    </div>
  </section>

  <section class="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8 mb-20 px-4">
    <div class="bg-white p-8 rounded-2xl border border-slate-100 shadow-sm hover:shadow-md transition-shadow">
      <div
        class="w-12 h-12 bg-indigo-50 text-indigo-600 rounded-xl flex items-center justify-center mb-6 text-2xl pi pi-bolt"></div>
      <h3 class="text-xl font-bold text-slate-800 mb-3">Live 5-Minute Data</h3>
      <p class="text-slate-500 leading-relaxed">
        The underlying data is updated every 5 minutes, dating back to January 1, 2012. Stay constantly synchronized
        with the market's pulse.
      </p>
    </div>

    <div class="bg-white p-8 rounded-2xl border border-slate-100 shadow-sm hover:shadow-md transition-shadow">
      <div
        class="w-12 h-12 bg-pink-50 text-pink-600 rounded-xl flex items-center justify-center mb-6 text-2xl pi pi-chart-pie"></div>
      <h3 class="text-xl font-bold text-slate-800 mb-3">Comprehensive Aggregation</h3>
      <p class="text-slate-500 leading-relaxed">
        Daily, weekly, monthly, quarterly, and annual displays are updated twice a day (9 am and 6 pm UTC) for long-term
        strategic analysis.
      </p>
    </div>

    <div class="bg-white p-8 rounded-2xl border border-slate-100 shadow-sm hover:shadow-md transition-shadow">
      <div
        class="w-12 h-12 bg-emerald-50 text-emerald-600 rounded-xl flex items-center justify-center mb-6 text-2xl pi pi-download"></div>
      <h3 class="text-xl font-bold text-slate-800 mb-3">Export & Cite</h3>
      <p class="text-slate-500 leading-relaxed">
        Easily screenshot charts or download root CSV data. We provide clear citation formats for academic and
        professional reporting.
      </p>
    </div>
  </section>

  <section class="max-w-5xl mx-auto mb-20 px-4">
    <div class="bg-white rounded-3xl p-8 md:p-12 shadow-sm border border-slate-100">
      <h2 class="text-2xl font-bold text-slate-800 mb-6 border-b border-slate-100 pb-4">About the Dashboard Data</h2>

      <div class="prose prose-slate prose-lg max-w-none">
        <p class="text-justify mb-6 text-slate-600">
          <strong>V-NEM</strong> is a tool for investigation of the Australian National Electricity Market's data. Its
          displays are intended to be valuable as prima facie for scholars, advisors, administrators and executives & as
          a way to stimulate ideas that can then be pursued through easy access to the underlying data.
        </p>

        <p class="text-justify mb-6 text-slate-600">
          <span
            (click)="op.toggle($event)"
            class="font-bold text-[#6d28d9] underline decoration-pink-500/30 hover:decoration-pink-500 decoration-2 cursor-pointer transition-colors">
            The underlying data
          </span>
          in this dashboard is updated every 5 minutes, and it starts on 1 January 2012. The 5-minute and 30-minute data
          series is updated every five minutes. All other displays (daily, weekly, monthly, quarterly and annually) are
          updated twice per
          <span
            (click)="opDay.toggle($event)"
            class="font-bold text-[#6d28d9] underline decoration-pink-500/30 hover:decoration-pink-500 decoration-2 cursor-pointer transition-colors">
            day.
          </span>
          <strong>V-NEM</strong> covers the energy markets in the NEM, not the much smaller ancillary services markets.
        </p>

        <div class="bg-slate-50 border-l-4 border-indigo-500 p-6 rounded-r-xl mb-8 my-8">
          <p class="font-semibold text-slate-800 mb-2 mt-0">Suggested Citation:</p>
          <p class="italic text-slate-600 mb-0">
            Victoria Energy Policy Centre, [YYYY]. Data sourced from the Australian Energy Market Operator, processed
            and accessed through the Victoria Energy Policy Centre V-NEM data dashboard. www.vepc.org.au. Accessed
            [Date].
          </p>
        </div>

        <p class="text-justify mb-3 text-slate-600">
          If you wish to screenshot charts, click on the <strong>“Maximise panel”</strong> icon to get a clearer image.
          Root data in the chart displays can be downloaded (click on the <strong>“File”</strong> icon for each chart).
          <span
            (click)="opFive.toggle($event)"
            class="font-bold text-[#6d28d9] underline decoration-pink-500/30 hover:decoration-pink-500 decoration-2 cursor-pointer transition-colors">
            Five-minute
          </span>
          data for long periods (from 2012 onwards) can be purchased. Use of the dashboard is subject to the
          <a class="text-indigo-600 font-medium hover:underline" (click)="openTerms()" href="javascript:void(0)"
            >Terms of Use</a
          >. Feedback is valued, please
          <a class="text-indigo-600 font-medium hover:underline" href="mailto:bruce.mountain@vu.edu.au" target="_blank"
            >contact us</a
          >
          for questions or comments.
        </p>
      </div>
    </div>
  </section>

  <section class="max-w-6xl mx-auto mb-32 px-4 sm:px-6 lg:px-8">
    <div
      class="relative rounded-[2rem] bg-[#16142b] shadow-[0_20px_50px_-12px_rgba(22,20,43,0.5)] border border-slate-800/50 overflow-hidden ring-1 ring-white/10 p-2 md:p-4">
      <div class="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-white/10 to-transparent"></div>

      <div class="relative w-full h-full rounded-2xl overflow-hidden bg-[#0f0e1c]">
        <nem-yt-video></nem-yt-video>
      </div>
    </div>
  </section>

  <p-popover #op [dismissable]="true" styleClass="shadow-xl rounded-xl border border-slate-200">
    <div class="p-3 max-w-2xl">
      <h4 class="font-bold text-slate-800 mb-2">Underlying Data Fields:</h4>
      <span
        class="text-sm text-slate-600 leading-relaxed font-mono bg-slate-50 p-2 block rounded border border-slate-100">
        SETTLEMENTDATE, DUID, TOTALCLEARED, AVAILABILITY, REGIONID, RRP, INTERCONNECTORID, METEREDMWFLOW, EXPORTLIMIT,
        IMPORTLIMIT, DEMAND_AND_NONSCHEDGEN, SCADAVALUE, INTERVAL_DATETIME, REGIONID
      </span>
    </div>
  </p-popover>

  <p-popover #opDay [dismissable]="true" styleClass="shadow-xl rounded-xl border border-slate-200">
    <div class="p-3 max-w-lg">
      <span class="text-sm text-slate-600 leading-relaxed">
        All displays longer than 30 minutes, except Residual Demand and VWAP, are updated at 9 am and 6 pm UTC each day.
        Residual Demand is updated once daily at 4:20 pm, and VWAP is updated at 5:30 pm UTC.
      </span>
    </div>
  </p-popover>

  <p-popover #opFive [dismissable]="true" styleClass="shadow-xl rounded-xl border border-slate-200">
    <div class="p-3 max-w-xl">
      <h4 class="font-bold text-slate-800 mb-3">Available Data Series:</h4>
      <ul class="flex flex-wrap gap-2 text-sm text-slate-600 list-none p-0 m-0">
        @for (name of listOfMethodNames; track name) {
        <li class="bg-indigo-50 text-indigo-700 px-2 py-1 rounded-md border border-indigo-100">
          {{ name }}
        </li>
        }
      </ul>
    </div>
  </p-popover>
</nem-layout>
